import React, { useEffect, useState } from "react";
import { SOCIAL_LOGIN, SOCIAL_LOGIN_SAVE } from "../utils/constants/apiUrl";
import { post } from "../server";
import { useAtom } from "jotai";
import { accountType, loggedInUser } from "../utils/store";
import useFunctionsCount from "../hooks/useFunctionsCount";
import showToast from "../helpers/showToast";
import { useNavigate } from "react-router-dom";

const LinkedInCallback = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const { userActions } = useFunctionsCount();
  const [personalAccount, setPersonalAccount] = useAtom(accountType);
  const navigate = useNavigate();
  const sendSocialToken = async (user, token) => {
    setLoading(true);
    let payload = user;
    payload.first_name = user.first_name;
    payload.last_name = user.last_name;
    payload.token = user?.linkdin_token;
    payload.provider_type = "linkedin";
    let { status, message, data } = await post(SOCIAL_LOGIN, payload);
    if (status) {
      await post(
        SOCIAL_LOGIN_SAVE,
        {
          provider_type: "linkedin",
          token: user?.linkdin_token,
          email: user.email,
          first_name: user.first_name,
          last_name: user.last_name,
        },
        data.token
      );
      if (Object.keys(data).length > 0) setLoggedUser(data);
      userActions(data);
      setPersonalAccount(true);

      if (window.opener) {
        window.opener.postMessage({ type: "LINKEDIN_LOGIN_SUCCESS" }, "*");
        window.close();
      } else {
        navigate("/");
      }
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };
  useEffect(() => {
    const handleLinkedInCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const dataParam = params.get("data");

      if (!dataParam) {
        console.error("No data parameter found in URL");
        return;
      }

      try {
        // Decode URL-encoded JSON string
        const decodedData = decodeURIComponent(dataParam);
        const parsedData = JSON.parse(decodedData);

        console.log("✅ LinkedIn callback data:", parsedData);

        // Example: access user & token
        const user = parsedData?.user;
        const token = parsedData?.token;

        console.log("User:", user);
        console.log("Token:", token);

        // Save to localStorage or context if needed
        // localStorage.setItem("user", JSON.stringify(user));
        // localStorage.setItem("token", token);

        // Optionally redirect to dashboard or home
        // window.location.href = "/dashboard";
        if (user && token) {
          sendSocialToken(user, token);
        }
      } catch (error) {
        console.error("Error parsing LinkedIn callback data:", error);
      }
    };

    handleLinkedInCallback();
  }, []);

  return <div>Processing LinkedIn login…</div>;
};

export default LinkedInCallback;
